export { LandingPage } from "./landing-page";

